import METADATA from "./ConfigurationEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class ConfigurationEntity extends BaseEntity {
  constructor(id, confKey, confValue, confDesc, moduleCode) {
    super();
    this.id = id;
    this.confKey = confKey;
    this.confValue = confValue;
    this.confDesc = confDesc;
    this.moduleCode = moduleCode;
  }
}

METADATA.connect(ConfigurationEntity);

export { ConfigurationEntity };
